module.exports = __webpack_public_path__ + "media/与供应链的深度融合.aba4ed88.mp4";